import { createEventTracker } from '../util';
import { DeletionQueuedAnalytics, DetectionsCategorizationAnalytics } from './types';

export const trackDeletionQueued =
  createEventTracker<DeletionQueuedAnalytics>('Segment-Based Deletion');

export const trackDetectionEventCategorized = createEventTracker<DetectionsCategorizationAnalytics>(
  'Detection Event Categorized',
);
